import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-privacy-policy',
    standalone: true,
    imports: [CommonModule, RouterModule],
    template: `
    <div class="policy-container">
      <header>
        <button class="btn-back" [routerLink]="['/']">
          <span class="material-symbols-outlined">arrow_back</span>
          {{ t('back') }}
        </button>
        <h1>{{ t('privacy_title') }}</h1>
      </header>

      <main class="content glass-card">
        <section>
            <h2>1. {{ t('privacy_intro_title') }}</h2>
            <p>{{ t('privacy_intro_text') }}</p>
        </section>

        <section>
            <h2>2. {{ t('privacy_cookies_title') }}</h2>
            <p>{{ t('privacy_cookies_text') }}</p>
            <ul>
                <li><strong>Google AdSense:</strong> {{ t('privacy_adsense_text') }}</li>
                <li><strong>LocalStorage:</strong> {{ t('privacy_local_text') }}</li>
            </ul>
            <p>
                <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener">
                    {{ t('privacy_google_link') }}
                </a>
            </p>
        </section>

        <section>
            <h2>3. {{ t('privacy_rights_title') }}</h2>
            <p>{{ t('privacy_rights_text') }}</p>
        </section>

        <section>
            <h2>4. {{ t('privacy_contact_title') }}</h2>
            <p>{{ t('privacy_contact_text') }}</p>
        </section>
      </main>
    </div>
  `,
    styles: [`
    .policy-container {
      max-width: 800px;
      margin: 0 auto;
      padding: 2rem 1rem;
      min-height: 100vh;
    }
    header {
      margin-bottom: 2rem;
    }
    .btn-back {
      background: none;
      border: none;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: 600;
      cursor: pointer;
      color: var(--text-muted);
      margin-bottom: 1rem;
      font-size: 1rem;
    }
    .btn-back:hover { color: var(--text-dark); }
    h1 { font-size: 2.5rem; color: var(--text-dark); margin-bottom: 0.5rem; }
    
    .content {
      padding: 2.5rem;
      background: rgba(255,255,255,0.9);
      line-height: 1.7;
      color: #444;
    }
    section { margin-bottom: 2.5rem; }
    h2 { font-size: 1.4rem; color: var(--text-dark); margin-bottom: 1rem; border-bottom: 1px solid #eee; padding-bottom: 0.5rem; }
    ul { padding-left: 1.5rem; margin: 1rem 0; }
    li { margin-bottom: 0.5rem; }
    a { color: var(--primary-pastel); font-weight: 600; text-decoration: none; border-bottom: 1px solid transparent; transition: all 0.2s; }
    a:hover { border-bottom-color: currentColor; }

    @media (max-width: 768px) {
        .content { padding: 1.5rem; }
        h1 { font-size: 1.8rem; }
    }
  `]
})
export class PrivacyPolicyComponent {
    constructor(private langService: LanguageService) { }

    t(key: string): string {
        return this.langService.translate(key);
    }
}
